<template>
  <div class="exam typeing">
    <div class="nuv">
      <a href="/tjkStudy/examlist" class="active">考试中心</a>&gt;<span>{{ data.examName }}</span>
    </div>
    <div class="left">
      <div class="exam-con">
        <h2>{{ data.examName }}</h2>
        <div class="content typing-con">
          <template v-for="(l, key) in paperlist">
            <p class="row-con" v-html="l.lastcontent"></p>
            <input class="typing-input" v-model="l.input" @keyup="computeFun(key, $event)" :maxlength="l.maxlength" onpaste="return false" />
          </template>
        </div>
      </div>
    </div>
    <div class="right">
      <div class="count">
        <h2>统计</h2>
        <div class="useTime">
          <p>距自动交卷时间</p>jingmai
          <span class="blue">{{ time }}</span>
        </div>
        <div class="useTime">
          <p class="txt">速度：{{ lastspeed }}字/分</p>
        </div>
        <div class="useTime">
          <p class="txt">正确率：{{ ratio }}%</p>
        </div>
        <div class="useTime">
          <p class="txt">总字数：{{ totalNum }}字</p>
        </div>
        <div class="useTime">
          <p class="txt">错误：{{ errorNum }}字</p>
        </div>
        <div class="btn" v-if="isShowBtn == true">
          <div class="submit typing" @click="submitExam">提交试卷</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      'success': true,
      'message': '',
      'id': this.$route.params.id, //examConfigId
      'data': {},
      'examRecordId': '',
      'endTime': '', //初始化考试剩余时间
      'time': '', //考试剩余时间-时分秒
      'secTime': '', //考试剩余时间-秒
      'isShowBtn': false,
      'paper': '',
      'paperlist': [],
      'examRecordId': '',
      'totalTime': 0, //考试总时间
      'errorNum': 0,  //错误字数
      'paperWords': 0,//考试总字数
       OnInline:'fales'//小助手跳转
    }
  },
  mounted: function() {
    this.getExam()
  },
  computed: {
    //输入总字数
    totalNum: function() {
      var num = 0
      for(var i=0;i<this.paperlist.length;i++) {
        num = num + this.paperlist[i].input.length
      }
      if(num < this.paperWords) {
        this.isShowBtn = false
      }else {
        this.isShowBtn = true
      }
      return num
    },
    //正确率
    ratio: function() {
      var temp = ((this.totalNum - this.errorNum) / this.totalNum) * 100,
          temp = isNaN(temp) ? 0 : temp.toFixed(2)
      return temp
    },
    //打字速度
    lastspeed: function() {
      var value = Math.round(this.totalNum / (this.totalTime - this.secTime) * 60),
          value = isNaN(value) ? 0 : value
      return value
    }
  },
  watch: {
    paperlist: {
      handler: function (val, oldVal) {
        this.errorNum = 0
        for(var m=0;m<this.paperlist.length;m++) {
          var contentArray = this.paperlist[m].content.split(''),
              inputArray = this.paperlist[m].input.split(''),
              str = '',
              index = 0,
              length = 0

          //如果输入的文字长度小于等于测试长度
          if(inputArray.length <= contentArray.length) {
            for(var i=0;i<inputArray.length;i++) {
              if(inputArray[i] != contentArray[i]) {
                str = str + '<span class="c-red">' + contentArray[i] + '</span>'
              } else {
                str = str + '<span class="c-green">'+ contentArray[i] + '</span>'
              }
            }

            //计算打字错误总字数
            var regValue=/(<span class="c-red"\s?[^\>]*>.*?<\/span>)/gi    
            var errorArray = str.split(regValue)

            for(var n=0;n<errorArray.length;n++) {
              if(errorArray[n].indexOf('c-red') > 0) {
                this.errorNum = this.errorNum + 1
              }
            }

            index = inputArray.length
            length = contentArray.length - inputArray.length
            this.paperlist[m].lastcontent = str + this.paperlist[m].content.substr(index,length)
          }
        }
      },
      deep: true
    }
  },
  methods: {
    getExam() {
      var data = {
        'examConfigId': this.id
      }
      this.$http.post(API_ROOT.system + '/tjkExam/startExam', data).then(response => {
        var result = response.data
        this.success = result.success
        this.message = result.msg
        if (result.success) {
          this.data = result.data
          this.paper = result.data.paperQuestion[0].questionDetailList[0].question.questionContent.questionStemString
          this.totalTime = result.data.examRemainingTime
          this.paperWords = result.data.paperQuestion[0].questionDetailList[0].question.wordNumber
          this.examRecordId = result.data.examRecordId
          this.paperInit()
          if(this.endTime == '') this.endTime = result.data.examRemainingTime
          this.countdown(this.endTime)
        }else {
          alert(result.msg)
          window.location.href = '/tjkStudy/examlist'
        }
      }, response => {
        alert('网络繁忙，请稍后重试！')
      })
    },
    //拆分文章
    paperInit() {
      var width = $('.left').width(),
          content = this.paper.trim(),
          size = ( width * 0.9 ) / 15,
          size = Math.floor(size),
          row = Math.floor((content.length - 1) / size) + 1
      for(var i=0;i<row;i++) {
        var rsult = content.substr(i * size, size),      
            temp = {
              'lastcontent': rsult,
              'content': rsult,
              'maxlength': rsult.length,
              'input': ''
            }
        this.paperlist.push(temp)
      }
    },
    //倒计时
    countdown(endTime) {
      var self = this
      var timer = setInterval(function() {
        endTime--
        self.secTime = endTime

        if(endTime >= 0) {
          var sec = parseInt(endTime)
          var min = 0
          var hour = 0  
          if(sec > 60) {
            min = parseInt(sec/60)
            sec = parseInt(sec%60)
            if(min > 60) {
              hour = parseInt(min/60)
              min = parseInt(min%60)
            }
          }
          hour = hour < 10 ? "0" + hour : hour
          min = min < 10 ? "0" + min : min
          sec = sec < 10 ? "0" + sec : sec
          if(hour > 0 ) {
            self.time = `${hour}:${min}:${sec}`
          }else {
            self.time =`${min}:${sec}`
          }
          if(endTime == 300) {
            self.open()
          }
        }else {
          clearInterval(timer)
          self.time = '时间到'
          self.isShowBtn = true
          self.submitExamNoconfirm()
        }
      },1000)
    },
    computeFun(key, e) {
      //输入框超过考试内容自动换行
      var max = this.paperlist[key].maxlength
      if(this.paperlist[key].input.length == 0) {
        return false
      }
      if(this.paperlist[key].input.length >= max) {
        this.paperlist[key].input = this.paperlist[key].input.slice(0, max)
        this.paperlist[key+1].input = this.paperlist[key+1].input + this.paperlist[key].input.slice(max)
        $(e.currentTarget).next().next().focus()
      }
    },
    //考试时间提示框
    open() {
      const h = this.$createElement
      this.$notify({
        title: '',
        message: h('i', { style: 'color: red'}, '离自动交卷还有5分钟，请注意答题时间'),
        duration: 5000
      })
    },
    //提交考试前保存——自动提交
    submitExamNoconfirm() {
      var arry = [],
          list = {
            'speed': this.lastspeed,
            'accuracy': this.ratio,
            'tjkWordNumber': this.totalNum,
            'spentTime': this.totalTime - this.secTime
          }
      arry[0] = {
        'examRecordId': this.examRecordId,
        'sequence': 1,
        'tjkAnswerString': JSON.stringify(list)
      }

      var data = {
        'tjkAnswerDetailList': arry
      }
      this.$http.post(API_ROOT.system + '/tjkExam/submitTjkAnswer', data).then(response => {
        var result = response.data
        this.success = result.success
        this.message = result.msg
        if (result.success) {
          this.submitExamFun()
        }else {
          alert(result.msg)
        }
      }, response => {
        alert('网络繁忙，请稍后重试！')
      })
    },
    //提交考试前保存——手动提交
    submitExam() {
      var arry = [],
          list = {
            'speed': this.lastspeed,
            'accuracy': this.ratio,
            'tjkWordNumber': this.totalNum,
            'spentTime': this.totalTime - this.secTime
          }
      arry[0] = {
        'examRecordId': this.examRecordId,
        'sequence': 1,
        'tjkAnswerString': JSON.stringify(list)
      }

      var data = {
        'tjkAnswerDetailList': arry
      }
      if(confirm("您确定要提交考试吗？")) {
        this.$http.post(API_ROOT.system + '/tjkExam/submitTjkAnswer', data).then(response => {
          var result = response.data
          this.success = result.success
          this.message = result.msg
          if (result.success) {
            this.submitExamFun()
          }else {
            alert(result.msg)
          }
        }, response => {
          alert('网络繁忙，请稍后重试！')
        })
      }
    },
    //提交考试
    submitExamFun() {
      var data = {
        'examRecordId': this.examRecordId
      }
      this.$http.post(API_ROOT.system + '/tjkExam/submitNormalExam', data).then(response => {
        var result = response.data
        this.success = result.success
        this.message = result.msg
        if (result.success) {
          this.$message({
            message: '已提交',
            type: 'success',
            center: true,
            duration: 1000
          })
          if(this.OnInline=='true'){ 
            window.location.href = '/tjkStudy/typingResult/' + this.examRecordId+'&OnInline='+this.OnInline}
            else{
              window.location.href = '/tjkStudy/typingResult/' + this.examRecordId
            }
          
        }else {
          alert(result.msg)
        }
      }, response => {
        alert('网络繁忙，请稍后重试！')
      })
    }
  }
}
</script>


// WEBPACK FOOTER //
// ./src/page/examTyping.vue